export enum WorkforcePlanRequestType {
    REQUEST_DISMISSAL = "REQUEST_DISMISSAL",
    REQUEST_TRAINING = "REQUEST_TRAINING",
    REQUEST_APTITUDE_TRAINING = "REQUEST_APTITUDE_TRAINING",
    SHIFT_CHANGE = "SHIFT_CHANGE",
    REQUEST_HIRING_SUBSTITUTION = "REQUEST_HIRING_SUBSTITUTION",
    COST_CENTER_AND_JOB_TITLE_CHANGE = "COST_CENTER_AND_JOB_TITLE_CHANGE",
    // JOBTITLE_CHANGE= "JOBTITLE_CHANGE",
    REQUEST_HIRING_INCREASE = "REQUEST_HIRING_INCREASE",
    REQUEST_WORK_FORCEPLAN = "REQUEST_WORK_FORCEPLAN",
    REQUEST_HIRING_REPLACEMENT = "REQUEST_HIRING_REPLACEMENT",
    REQUEST_PROMOTION = "REQUEST_PROMOTION",
    REQUEST_DISCIPLINARY_MEASURE = "REQUEST_DISCIPLINARY_MEASURE",
    REQUEST_FEEDBACK = "REQUEST_FEEDBACK"
}
